import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppointmentService } from 'src/app/services/appointment/appointment.service';
import * as AppointmentActions from './appointment.actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class AppointmentEffects {
  constructor(
    private actions$: Actions,
    private appointmentService: AppointmentService
  ) {}

  loadUpcomingAppointments = createEffect(() =>
    this.actions$.pipe(
      ofType(
        AppointmentActions.loadUpcomingAppointments,
        AppointmentActions.refreshUpcomingAppointments
      ),
      switchMap(() =>
        this.appointmentService.getUpcomingAppointmentsForCustomer().pipe(
          map((appointments) =>
            AppointmentActions.loadUpcomingAppointmentsSuccess({
              appointments,
            })
          ),
          catchError((error) =>
            of(
              AppointmentActions.loadUpcomingAppointmentsFailure({
                error: error.message || 'Failed to load upcoming appointments',
              })
            )
          )
        )
      )
    )
  );
}

